import React from 'react';
import wrapStore from '@src/utils/wrap-store';
// import VideoModalStore from '@src/business-components/video-modal/store';
import VideoModalStore from './store';
import ModalContainer from '@src/components/modal-container';
import { noop } from '@src/utils/common-util';
import YtVideo from '@src/business-components/yt-video';

const styles = require('./index.less');

/**
 * VideoModal
 * @param store {VideoModalStore}
 * @param onClose
 * @returns {JSX.Element}
 * @constructor
 */
const VideoModal = ({ store, onClose = noop }) => {
  store.use();
  store.onClose = onClose;

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={styles.root}>
        <div className={styles.closeBtn} onClick={store.onCloseBtnClick} />
        <div className={styles.videoContainer}>{store.src && <YtVideo videoId={store.src} />}</div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(VideoModal, VideoModalStore);
